if (!customElements.get('size-guide-drawer')) {
  customElements.define(
    'size-guide-drawer',
    class SizeGuideDrawer extends HTMLElement {
      constructor() {
        super()

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide()
        })

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide()
        })

        this.renderPreview()
      }

      renderPreview() {
        const drawer = document.querySelector('size-guide-drawer');
        if (drawer) drawer.remove();

        document.body.appendChild(drawer);

        const button = document.querySelector('#ShowSizeGuideDrawer')
        if (button) {
          button.addEventListener('click', (evt) => {
            document.querySelector('size-guide-drawer').show(evt.target)
          })
        }
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('size-guide-drawer') &&
          target.id != 'ShowSizeGuideDrawer'
        ) {
          this.hide()
        }
      }

      hide() {
        this.removeAttribute('open')
        document.body.removeEventListener('click', this.onBodyClick)
        document.body.classList.remove('overflow-hidden')
        removeTrapFocus(this.focusElement)
      }

      show(focusElement) {
        this.focusElement = focusElement
        this.setAttribute('open', '')
        document.body.addEventListener('click', this.onBodyClick)
        document.body.classList.add('overflow-hidden')
        trapFocus(this)
      }
    }
  );
}